import { motion, useAnimation, useInView } from "framer-motion";
import React, { useEffect, useRef } from "react";

// initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, type: "tween", delay: 0.7 }}

const Reveal = ({ children, delay = 0.25 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isInView) {
      mainControls.start("visible");
    }
  }, [isInView]);

  return (
    <motion.div
      ref={ref}
      variants={{
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
      }}
      initial="hidden"
      animate={mainControls}
      transition={{ duration: 0.3, type: "tween", delay }}
      className="h-100">
      {children}
    </motion.div>
  );
};

export default Reveal;
